import { render, staticRenderFns } from "./loadingView.vue?vue&type=template&id=4c729f0a&scoped=true"
import script from "./loadingView.vue?vue&type=script&lang=js"
export * from "./loadingView.vue?vue&type=script&lang=js"
import style0 from "./loadingView.vue?vue&type=style&index=0&id=4c729f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c729f0a",
  null
  
)

export default component.exports